export const entity = require("./../../utils/entityJoin").joinEntities({name: "FamilyAxisJoin"},
    ["FamilyAxis", "ProductAxis"])
